export async function getWoowPaymentLink({
  amount,
  description,
  token,
  period,
  email,
  uid,
  vid,
  vehicleType,
  firstName,
  campaign = "woow",
}) {
  const baseURL =
    "https://clupp-api.web.app/v1/clupp/integrations/wow/payment-link";

  try {
    const response = await fetch(baseURL, {
      method: "POST",
      headers: {
        Origin: "clupp",
        Referer: "clupp",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount,
        token,
        description,
        period,
        email,
        uid,
        vid,
        vehicleType,
        firstName,
        campaign,
      }),
    });

    if (!response.ok) {
      const errorMessage = `Error ${response.status}: ${response.statusText}`;
      throw new Error(errorMessage);
    }

    const json = await response.json();

    if (!json.success) {
      throw new Error("Error: Respuesta no válida del servidor");
    }
    const { paymentLink } = json;
    if (!paymentLink) {
      throw new Error("Error: Respuesta no válida del servidor");
    }

    return paymentLink;
  } catch (error) {
    console.error("Error al realizar la solicitud:", error);
    return null;
  }
}

export async function getWoowEmployee(token) {
  const baseURL = "https://clupp-api.web.app/v1/clupp/integrations/wow/user";

  try {
    const response = await fetch(baseURL, {
      method: "POST",
      headers: {
        Origin: "clupp",
        Referer: "clupp",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      const errorMessage = `Error ${response.status}: ${response.statusText}`;
      throw new Error(errorMessage);
    }

    const json = await response.json();

    if (!json || !json.data) {
      throw new Error("Error: Respuesta no válida del servidor");
    }

    return json.data;
  } catch (error) {
    console.error("Error al realizar la solicitud:", error);
    return null;
  }
}
